/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect, useRef } from "react"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import moment from "moment"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,
  Badge,

  // CardTitle
} from "reactstrap"
import { connect } from "react-redux"
import PropTypes from "prop-types"
//Import Breadcrumb
// import { ReactSearchAutocomplete } from "react-search-autocomplete"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as optionsAction from "../../store/bGVhdmVPcHRpb25z/actions"
import * as employeeAction from "../../store/RW1wbG95ZWVSZXF1ZXN0/actions"
import { useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "../../components/ButtonSpinner"
// import { styles } from "../../pages/ClientDetails/Input-Select/select"
//Import Styles
import "./styles.scss"
import BootstrapTable from "react-bootstrap-table-next"
//import { CSVExport } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import SimpleReactValidator from "simple-react-validator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { toast, ToastContainer } from "react-toastify"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
// import { fromDateFunc, toDateFunc } from "helpers/tools"
import api from "../../helpers/Api"

const LeaveOptions = (props) => {
  const title = "Employee Default"
  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()

  const mode = "hrms"

  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  //pagination page,count
  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)

  // let id = useParams()
  useEffect(() => {
    dispatch(optionsAction.loadRecordsMetaData())
    dispatch(optionsAction.loadEmployee())
    dispatch(employeeAction.loadProcessStatus(mode))
    dispatch(
      optionsAction.loadLeaveAbsend({
        page: 1,
        limit: 50,
      })
    )
  }, [])
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")
  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        page: pageChange ? pageCount : 1,
        limit: 50,
      }

  const leaveUpdate = useSelector((specificstate) => specificstate.leaveOptions)
  const {
    recordsMetaData = {},
    employee_list = [],
    leave_list = [],
  } = leaveUpdate

  const [leaveOptionsData, setLeaveOptionsData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: "",
    fromDate: "",
    toDate: "",
    lossOfPay: [],
  })
  const handleChange = (e) => {
    console.log(e)
    setLeaveOptionsData({
      ...leaveOptionsData,
      [e.target.name]: e.target.value,
    })
  }

  // Access list
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  // console.log(user, "user details from session")

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //Lodin access
  //Access start
  const loginAccess = !isEmpty(user) && user ? user : []
  const leaveMenuDetails =
    !isEmpty(loginAccess) && loginAccess.menu
      ? loginAccess.menu.filter(
          (menu) => menu.menuId._id === "62417d99ce2eb68383527cfa"
        )
      : []

  const menuDetails =
    !isEmpty(leaveMenuDetails) && leaveMenuDetails.length > 0
      ? leaveMenuDetails.map((menu) => menu.menuId.menuSubHeader)
      : []

  const accessIdDetails =
    !isEmpty(menuDetails) && menuDetails.length > 0
      ? menuDetails[0].filter(
          (data) =>
            data._id === "63443344686501ccce051878" ||
            data._id === "6391ff585480a0031bad84a7"
        )
      : []

  const leaveRequestMenuDetails =
    !isEmpty(accessIdDetails) && accessIdDetails.length > 0
      ? accessIdDetails.map((data) => data.menuId.menuItem)
      : []
  const leaveRequestDetails =
    !isEmpty(leaveRequestMenuDetails) && leaveRequestMenuDetails.length > 0
      ? leaveRequestMenuDetails[0].filter(
          (data) =>
            data.menuId._id === "63e087a8d4d5b156bc2346f0" ||
            data.menuId._id === "63e89661b23682826dc66e26"
        )
      : []

  const accessDetails =
    !isEmpty(leaveRequestDetails) && leaveRequestDetails.length > 0
      ? leaveRequestDetails.map((menu) => menu.access)
      : []

  //Leave Edit Access

  const leaveEditRoleAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
          (data) => data._id === "61bc3037e2e60e99196975fe"
        )
      : []

  const leaveEditAccessId =
    !isEmpty(leaveEditRoleAccess) && leaveEditRoleAccess.length > 0
      ? leaveEditRoleAccess[0]._id
      : []
  //Leave Delete Access
  const leaveDeleteRoleAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
          (data) => data._id === "61bc3056e2e60e9919697601"
        )
      : []

  const leaveDeleteAccessId =
    !isEmpty(leaveDeleteRoleAccess) && leaveDeleteRoleAccess.length > 0
      ? leaveDeleteRoleAccess[0]._id
      : []

  console.log(leaveRequestDetails, "leaveRequestDetails")
  console.log(leaveRequestMenuDetails, "leaveRequestMenuDetails")
  console.log(menuDetails, "menuDetails")
  // console.log(accessDetails, "accessDetails")
  // console.log(leaveEditAccessId, "leaveEditAccessId")
  // console.log(leaveDeleteAccessId, "leaveDeleteAccessId")
  // console.log(accessIdDetails, "accessIdDetails")
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentlist, setDepartmentlist] = useState([])
  const [employeeCode, setEmployeeCode] = useState([])
  const [lopStatus, setLopStatus] = useState([])

  //Apply lead modal Data
  //Apply leave modal
  const [applyLeaveModal, setApplyLeaveModal] = useState(false)
  const handleLeaveModal = () => setApplyLeaveModal(false)

  const [confirmModalView, setConfirmModalView] = useState(false)
  const handleConfirmModal = () => setConfirmModalView(false)

  const [empCodeData, setEmpCodeData] = useState([])
  // const [leaveStatusData, setLeaveStatusData] = useState([])
  //Leave edit
  // const [leaveDuration, setLeaveDuration] = useState([])
  const [leaveAttachment, setLeaveAttachment] = useState([])
  const [leaveLopStatus, setLeaveLopStatus] = useState([])
  const [absentType, setAbsentType] = useState([])
  const [leaveApplyData, setLeaveApplyData] = useState({
    company: "",
    branch: "",
    designation: "",
    department: "",
    fromDate: "",
    lossOfPay: "",
    toDate: "",
    reason: "",
    date: "",
    absentDate: "",
    toTime: "",
    fromTime: "",
  })
  const handleleaveChange = (e) => {
    setLeaveApplyData({ ...leaveApplyData, [e.target.name]: e.target.value })
  }

  const employeeChange = (e) => {
    setEmpCodeData(e)

    leaveApplyData.company = e ? e.companyName : ""
    leaveApplyData.branch = e ? e.branchName : ""
    leaveApplyData.department = e ? e.departmentName : ""
    leaveApplyData.designation = e ? e.designationName : ""

    setLeaveApplyData(leaveApplyData)
  }

  //Apply leave modal end
  const [deleteModal, setDeleteModal] = useState(false)
  const [leaveRemoveId, setLeaveRemoveId] = useState("")
  // const [empId, setEmpId] = useState("")
  //Attchment code
  const [rejectAttachment, setRejectAttachment] = useState([])
  const [attachmentFile, setAttachmentFile] = useState("")

  const [openModal, setOpenModal] = useState(false)
  const handleModal = () => setOpenModal(false)

  const [approvalView, setApprovalView] = useState(false)
  const handleApprovalModal = () => setApprovalView(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [leaveTypeList, setLeaveTypeList] = useState([])
  // const [responseStatus, setResponseStatus] = useState([])
  const [requestNo, setRequestNo] = useState("")
  const [leaveId, setLeaveId] = useState("")

  //Process status options creations
  const employeeUpdate = useSelector(
    (specificstate) => specificstate.employeeRequest
  )
  const { process_status = [] } = employeeUpdate
  // console.log(process_status, "process_status")

  const processStatusList =
    !isEmpty(process_status) &&
    process_status.map((process) => {
      return {
        _id: process._id,
        colorCode: process.colorCode,
        description: process.description,
        mode: process.mode,
        processStatus: process.processStatus,
        processStatusId: process.processStatusId,
        shortCode: process.shortCode,
      }
    })

  const createProcessOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        ;(obj.value = element.processStatusId),
          (obj.label = element.processStatus),
          (obj.colorCode = element.colorCode),
          (obj.mode = element.mode),
          (obj.id = element._id),
          options.push(obj)
      })
    return options
  }

  // const processStatusOptions = createProcessOptions(processStatusList)
  const updateProcessStatus = createProcessOptions(processStatusList)
  // const leaveStatusOptions = createProcessOptions(processStatusList)
  console.log(updateProcessStatus, "updateProcessStatus")

  //Update LPND status
  const [isLoading, setIsLoading] = useState(false)
  const [processRequest, setProcessRequest] = useState(false)
  const handleProcess = () => setProcessRequest(false)

  // const [updateProcess, setUpdateProcess] = useState([])
  const [updateData, setUpdateData] = useState({
    responseNotes: "",
    responseStatus: "",
    requestNo: "",
  })
  const updateChange = (e) => {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value })
  }
  const selectedCompanyIds = companies.map((company) => company.value)
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter((branch) =>
      selectedCompanyIds.includes(branch.companyId)
    )
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.name = element.name
        obj.companyId = element.companyId
        obj.companyName = element.companyName
        obj.branchId = element.branchId
        obj.branchName = element.branchName
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)
  const employeeCodeOptions = createOptions(employeeList)

  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const handleCompany = (e) => {
    setCompanies(e)
    setBranches([])
  }
  //submit values
  const handleApply = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchDepartment =
      departmentlist && departmentlist.value ? departmentlist.value : ""
    // var searchLeaveType =
    //   leaveTypeList && leaveTypeList.label ? [leaveTypeList.label] : ""
    var searchEmpCode =
      employeeCode && employeeCode.empCode ? employeeCode.empCode : ""

    var searchFromDate =
      leaveOptionsData && leaveOptionsData.fromDate
        ? leaveOptionsData.fromDate
        : ""
    var searchToDate =
      leaveOptionsData && leaveOptionsData.toDate ? leaveOptionsData.toDate : ""

    // var searchStatus = leaveStatus && leaveStatus.value ? leaveStatus.value : ""
    var searchLop = lopStatus && lopStatus.value ? lopStatus.value : ""
    console.log(employeeCode, "employee list")
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchDepartment) {
      searchvalue.departmentId = searchDepartment
    }
    if (searchEmpCode) {
      searchvalue.empCode = searchEmpCode
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchLop) {
      searchvalue.requestTypeId = searchLop
    }
    setSearchValueList(searchvalue)
    specificDispatch(optionsAction.loadLeaveAbsend(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }
  // console.log(employeeCode, "employee list")

  console.log(leaveTypeList, "filter functions")
  const [approvedData, setApprovedData] = useState("")

  // console.log(approvedData, "Apporved id from data table")
  // console.log(leaveStatus, "Leave Status")
  //Data table
  let slNo = 0
  const leaveDataTable = !isEmpty(leave_list)
    ? leave_list.data.map((leaveDetails, index) => {
        slNo = slNo + 1

        // const dateFormate =
        //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
        var str = !isEmpty(leaveDetails.attachment)
          ? leaveDetails.attachment
          : []

        // console.log(str, "string attachments")
        const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
        // console.log(fileUrl, "string attachments")
        const attachments = isEmpty(fileUrl)
          ? ""
          : "https://api.alphaone.app/uploads/" + fileUrl
        // console.log(attachments, "attachment with alpha url")
        var fromDateTime = !isEmpty(leaveDetails.fromDate)
          ? moment(leaveDetails.fromDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []

        var toDateTime = !isEmpty(leaveDetails.toDate)
          ? moment(leaveDetails.toDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []

        var appliedDate = !isEmpty(leaveDetails.createdAt)
          ? moment(leaveDetails.createdAt)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []
        var absentDate = !isEmpty(leaveDetails.absentDate)
          ? moment(leaveDetails.absentDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []
        var date = !isEmpty(leaveDetails.date)
          ? moment(leaveDetails.date)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []
        // const durationTime = !isEmpty(recordsMetaData)
        //   ? recordsMetaData.lossOfPayOptions.filter(
        //       (data) => data.label === leaveDetails.requestName
        //     )
        //   : []

        return {
          _id: leaveDetails._id,
          sNo: slNo,
          empCode: leaveDetails.employeeCode,
          action: (
            <div className="d-flex flex-row">
              {leaveEditAccessId === "61bc3037e2e60e99196975fe" ? (
                <>
                  {" "}
                  <Button
                    type="submit"
                    onClick={() => {
                      editLeaveDetails(leaveDetails)
                      setOpenModal(true)
                      setRequestNo(leaveDetails.requestNo)
                      setLeaveId(leaveDetails._id)
                      setAttachmentFile(attachments)
                      setEmployeeCodeDetails(leaveDetails)
                      // setPermissionradio(false)
                      // setLeaveradio(false)
                    }}
                    style={{ fontSize: "10px" }}
                    className="btn btn-success buttons"
                  >
                    <i
                      className="fas fa-pencil-alt icon-btn"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </>
              ) : (
                ""
              )}
              {leaveDeleteAccessId === "61bc3056e2e60e9919697601" ? (
                <Button
                  type="submit"
                  style={{ fontSize: "10px" }}
                  onClick={() => {
                    setLeaveRemoveId(leaveDetails._id)
                    setDeleteModal(true)
                    // setEmpId(leaveDetails.empId)
                  }}
                  className="mx-2 btn btn-danger"
                >
                  <i
                    className="bx bx-trash icon-btn font-size-10"
                    style={{ fontSize: "10px" }}
                  ></i>
                </Button>
              ) : (
                ""
              )}
            </div>
          ),
          branchId: leaveDetails.branchId,
          branchName: leaveDetails.branchName,
          companyId: leaveDetails.companyId,
          companyName: leaveDetails.companyName,
          departmentId: leaveDetails.departmentId,
          departmentName: leaveDetails.departmentName,
          designationId: leaveDetails.designationId,
          designationName: leaveDetails.designationName,
          requestTypeName: leaveDetails.requestName,
          requestTypeId: leaveDetails.requestTypeId,
          employeeCode: leaveDetails.empCode,
          employeeName: leaveDetails.empName,
          attachments: leaveDetails.attachment ? leaveDetails.attachment : "--",
          fromDate:
            leaveDetails.absentType === "Leave"
              ? fromDateTime
              : leaveDetails.absentType === "Permission"
              ? date
              : "--",
          toDate: leaveDetails.absentType === "Leave" ? toDateTime : "--",
          fromTime:
            leaveDetails.absentType === "Permission"
              ? leaveDetails.startTime
              : "--",
          toTime:
            leaveDetails.absentType === "Permission"
              ? leaveDetails.endTime
              : "--",
          request: leaveDetails.request,
          createdAt: appliedDate,
          absentDate: absentDate,
          absentStatus: leaveDetails.absentStatus
            ? leaveDetails.absentStatus
            : "--",
          absentMode: leaveDetails.absentMode,
          absentType: !isEmpty(leaveDetails.absentType)
            ? leaveDetails.absentType
            : "--",
          status: (
            <button
              onClick={() => {
                editUpdateStatus(leaveDetails)
                setLeaveId(leaveDetails._id)
                // setRequestStatus(leaveDetails.status)
              }}
              className={
                (leaveDetails.status === "Approved" &&
                  "approved-btn disabled-button") ||
                (leaveDetails.status === "Pending" && "pending-btn") ||
                (leaveDetails.status === "Onhold" && "hold-btn") ||
                (leaveDetails.status === "Recheck" && "recheck-btn") ||
                (leaveDetails.status === "Rejected" && "reject-btn") ||
                (leaveDetails.status === "Accepted" && "accept-btn")
              }
            >
              {leaveDetails.status}
            </button>
          ),
          leaveType: leaveDetails.leaveType,
          reason: leaveDetails.reason,
          requestNo: leaveDetails.requestNo,
          duration: leaveDetails.employeeSettingDuration,
          approvedBy: (
            <Button
              type="submit"
              onClick={() => {
                setRequestNo(leaveDetails.requestNo)
                setLeaveId(leaveDetails._id)
                setApprovalView(true)
                setApprovedData(leaveDetails.request)
              }}
              style={{ fontSize: "10px" }}
              className="btn btn-info buttons"
            >
              <i className="fas fa-eye icon-btn"></i>
            </Button>
          ),
          key: index,
        }
      })
    : []

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
    },
    {
      dataField: "companyName",
      text: "Company",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "designationName",
      text: "Designation",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Code",
      headerStyle: {
        minWidth: "90px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "absentType",
      text: "Absent Type",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "requestTypeName",
      text: "Employee Default Setting",
      headerStyle: {
        minWidth: "210px",
      },
    },
    {
      dataField: "absentDate",
      text: "Default Date",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "duration",
      text: "Duration(Hours)",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "reason",
      text: "Reason",
      headerStyle: {
        minWidth: "140px",
      },
    },

    // {
    //   dataField: "leaveType",
    //   text: "Leave Type",
    //   headerStyle: {
    //     minWidth: "90px",
    //   },
    // },

    {
      dataField: "fromDate",
      text: "From Date",
      headerStyle: {
        minWidth: "110px",
      },
    },
    {
      dataField: "toDate",
      text: "To Date",
      headerStyle: {
        minWidth: "110px",
      },
    },
    {
      dataField: "fromTime",
      text: "From Time",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "toTime",
      text: "To Time",
      headerStyle: {
        minWidth: "120px",
      },
    },
    // {
    //   dataField: "duration",
    //   text: "Duration",
    //   headerStyle: {
    //     minWidth: "140px",
    //   },
    // },
    {
      dataField: "attachments",
      text: "Attachment",
      formatter: (cellContent, row) => {
        var str = !isEmpty(row.attachments) ? row.attachments : []

        // console.log(str, "string attachments")
        const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
        // console.log(fileUrl, "string attachments")
        const attachments = isEmpty(fileUrl)
          ? ""
          : "https://api.alphaone.app/uploads/" + fileUrl
        return isEmpty(row.attachment) ? (
          ""
        ) : (
          <a onClick={() => window.open(attachments, "_blank")}>
            <span style={{ textDecoration: "underline", color: "#E40D8C" }}>
              View Attachments
            </span>
          </a>
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "absentStatus",
      text: "Absent Status",
      formatter: (cellContent, row) => {
        // console.log(row)
        return (row.absentStatus && row.absentStatus === "PS16") ||
          row.absentStatus === "Approved" ? (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.absentStatus === "Approved" || row.absentStatus === "PS16"
                ? "bg-danger badge-soft-danger"
                : "bg-success badge-soft-success"
            }`}
            pill
          >
            {row.absentStatus === "PS16" || row.absentStatus === "Approved"
              ? "Approved"
              : "Pending"}
          </Badge>
        ) : (
          ""
        )
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "createdAt",
      text: "Applied Date",
      headerStyle: {
        minWidth: "170px",
      },
    },
  ]

  //Search options
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState("")

  //Reset Functionalities
  const [resetEmployee, setResetEmployee] = useState(false)
  const resetFormDetails = () => {
    setDepartmentlist([])
    setEmployeeCode([])
    setCompanies([])
    setBranches([])
    setLeaveTypeList([])
    setSearchValueList({})
    setLeaveOptionsData({
      fromDate: "",
      toDate: "",
    })
    setLopStatus([])
    setResetEmployee(true)
    setTimeout(() => {
      setResetEmployee(false)
    }, 0)
    dispatch(
      optionsAction.loadLeaveAbsend({
        page: 1,
        limit: 50,
      })
    )
    setPageCount(1)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
    }, 2000)
  }

  const handleLeaveDetails = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      handleLeaveModal()
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setApplyLeaveModal(true)
      setConfirmModalView(false)
    }
  }

  console.log(lopStatus, "lopStatus")
  console.log(absentType.value, "absentType")
  const applyLeaveDetails = () => {
    if (absentType.value === "Leave") {
      const applyLeaveDetails = {
        empId: empCodeData.value,
        empName: empCodeData.name,
        empCode: empCodeData.empCode,
        companyId: empCodeData.companyId,
        branchId: empCodeData.branchId,
        departmentId: empCodeData.departmentId,
        designationId: empCodeData.designationId,
        absentType: absentType.value,
        absentMode: "Leave",
        requestTypeId: leaveLopStatus.value,
        absentDate: moment(leaveApplyData.absentDate).format("YYYY-MM-DD"),
        fromDate: moment(leaveApplyData.fromDate).format("YYYY-MM-DD"),
        toDate: moment(leaveApplyData.toDate).format("YYYY-MM-DD"),
        reason: leaveApplyData.reason,
        attachment: leaveAttachment[0],
        duration: "",
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "Approved",
        status: "1",
      }
      specificDispatch(optionsAction.applyLeaveAbsend(applyLeaveDetails))
    } else if (absentType.value === "Permission") {
      const applyLeaveDetails = {
        empId: empCodeData.value,
        empName: empCodeData.name,
        empCode: empCodeData.empCode,
        companyId: empCodeData.companyId,
        branchId: empCodeData.branchId,
        departmentId: empCodeData.departmentId,
        designationId: empCodeData.designationId,
        absentType: absentType.value,
        absentMode: "Leave",
        requestTypeId: leaveLopStatus.value,
        absentDate: moment(leaveApplyData.absentDate).format("YYYY-MM-DD"),
        date: moment(leaveApplyData.date).format("YYYY-MM-DD"),
        startTime: leaveApplyData.fromTime,
        endTime: leaveApplyData.toTime,
        // fromDate: moment(leaveApplyData.fromDate).format("YYYY-MM-DD"),
        // toDate: moment(leaveApplyData.toDate).format("YYYY-MM-DD"),
        reason: leaveApplyData.reason,
        attachment: leaveAttachment[0],
        duration: "",
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "Approved",
        status: "1",
      }
      specificDispatch(optionsAction.applyLeaveAbsend(applyLeaveDetails))
    } else {
      const applyLeaveDetails = {
        empId: empCodeData.value,
        empName: empCodeData.name,
        empCode: empCodeData.empCode,
        companyId: empCodeData.companyId,
        branchId: empCodeData.branchId,
        departmentId: empCodeData.departmentId,
        designationId: empCodeData.designationId,
        absentType: absentType.value,
        absentMode: "Leave",
        absentDate: moment(leaveApplyData.absentDate).format("YYYY-MM-DD"),
        requestTypeId: leaveLopStatus.value,
        // fromDate: moment(leaveApplyData.fromDate).format("YYYY-MM-DD"),
        // toDate: moment(leaveApplyData.toDate).format("YYYY-MM-DD"),
        reason: leaveApplyData.reason,
        attachment: leaveAttachment[0],
        duration: "",
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "Approved",
        status: "1",
      }
      specificDispatch(optionsAction.applyLeaveAbsend(applyLeaveDetails))
    }

    console.log(applyLeaveDetails, "leaveDetails")
    setIsLoading(true)
    setTimeout(() => {
      specificDispatch(optionsAction.loadLeaveAbsend(searchValue))
      toast.success("Leave Applied successfully")
      handleLeaveModal()
      setIsLoading(false)
    }, 2000)
  }

  const applyButton = () => {
    setEmpCodeData([])
    setLeaveApplyData({
      company: "",
      branch: "",
      designation: "",
      department: "",
      fromDate: "",
      toDate: "",
      reason: "",
    })
    // setLeaveDuration([])
    // setLeaveStatusData([])
    setLeaveLopStatus([])
    setAbsentType([])
  }

  // Leave modal popup functionality
  const [leaveModalLop, setLeaveModalLop] = useState([])
  const [absentTypeList, setAbsentTypeList] = useState([])
  const [leaveModalData, setLeaveModalData] = useState({
    companyDetail: "",
    branchDetail: "",
    departmentDetail: "",
    designationDetail: "",
    employeeCodeDetail: "",
    fromDateList: "",
    toDateList: "",
    lop: [],
    absentType: [],
    notes: "",
    responseRemarks: "",
    attachments: [],
    date: "",
    absentDate: "",
    fromTime: "",
    toTime: "",
  })

  const modalChange = (e) => {
    setLeaveModalData({ ...leaveModalData, [e.target.name]: e.target.value })
  }
  const [employeeCodeDetails, setEmployeeCodeDetails] = useState("")

  console.log(employeeCodeDetails, "employeeCodeDetails")
  //Edit leave details
  const editLeaveDetails = (leave) => {
    console.log(leave, "leave details")
    setAbsentTypeList({ label: leave.absentType, value: leave.absentType })
    setLeaveModalLop({
      label: leave.requestName,
      value: leave.requestTypeId,
    })

    setLeaveModalData({
      ...leaveModalData,
      companyId: leave.companyName,
      branchDetail: leave.branchName,
      departmentDetail: leave.departmentName,
      designationDetail: leave.designationName,
      employeeCodeDetail: leave.empCode,
      fromTime: leave.fromTime,
      toTime: leave.toTime,
      date: moment(leave.date).format("YYYY-MM-DD"),
      absentDate: moment(leave.absentDate).format("YYYY-MM-DD"),
      fromDateList: moment(leave.fromDate).format("YYYY-MM-DD"),
      toDateList: moment(leave.toDate).format("YYYY-MM-DD"),
      notes: leave.reason,
      absentType: [{ label: leave.absentType, value: leave.absentType }],
      responseRemarks: "",
      lop: [
        {
          label: leave.requestName,
          value: leave.requestTypeId,
        },
      ],
    })
  }

  //Update leave request in Modal popup

  const updateLeaveRequest = () => {
    if (absentTypeList.value === "Leave") {
      const leaveDetails = {
        _id: leaveId,
        empId: employeeCodeDetails.empId,
        empCode: employeeCodeDetails.empCode,
        empName: employeeCodeDetails.empName,
        companyId: employeeCodeDetails.companyId,
        branchId: employeeCodeDetails.branchId,
        departmentId: employeeCodeDetails.departmentId,
        designationId: employeeCodeDetails.designationId,
        absentType: absentTypeList.value,
        absentMode: "Leave",
        requestTypeId: leaveModalLop.value,
        fromDate: leaveModalData.fromDateList,
        toDate: leaveModalData.toDateList,
        absentDate: moment(leaveModalData.absentDate).format("YYYY-MM-DD"),
        duration: "2",
        reason: leaveModalData.notes,
        attachment: rejectAttachment[0],
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "PS16",
        status: "1",
      }
      specificDispatch(optionsAction.updateLeaveAbsend(leaveDetails))
    } else if (
      absentTypeList.value === "Permission" ||
      employeeCodeDetails.absentType === "Permission"
    ) {
      const leaveDetails = {
        _id: leaveId,
        empId: employeeCodeDetails.empId,
        empCode: employeeCodeDetails.empCode,
        empName: employeeCodeDetails.empName,
        companyId: employeeCodeDetails.companyId,
        branchId: employeeCodeDetails.branchId,
        departmentId: employeeCodeDetails.departmentId,
        designationId: employeeCodeDetails.designationId,
        absentType: absentTypeList.value,
        absentMode: "Permission",
        absentDate: moment(leaveModalData.absentDate).format("YYYY-MM-DD"),
        requestTypeId: leaveModalLop.value,
        date: leaveModalData.date,
        startTime: leaveModalData.fromTime,
        endTime: leaveModalData.toTime,

        duration: "2",
        reason: leaveModalData.notes,
        attachment: rejectAttachment[0],
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "PS16",
        status: "1",
      }
      specificDispatch(optionsAction.updateLeaveAbsend(leaveDetails))
    } else {
      const leaveDetails = {
        _id: leaveId,
        empId: employeeCodeDetails.empId,
        empCode: employeeCodeDetails.empCode,
        empName: employeeCodeDetails.empName,
        companyId: employeeCodeDetails.companyId,
        branchId: employeeCodeDetails.branchId,
        departmentId: employeeCodeDetails.departmentId,
        designationId: employeeCodeDetails.designationId,
        absentType: absentTypeList.value,
        absentDate: moment(leaveModalData.absentDate).format("YYYY-MM-DD"),
        absentMode:
          absentTypeList.value === "COC"
            ? "COC"
            : absentTypeList.value === "Late"
            ? "Late"
            : absentTypeList.value === "Others"
            ? "Others"
            : "",
        requestTypeId: leaveModalLop.value,
        duration: "2",
        reason: leaveModalData.notes,
        attachment: rejectAttachment[0],
        latitude: "12.36.123",
        longitude: "1456.215.144",
        absentStatus: "PS16",
        status: "1",
      }
      specificDispatch(optionsAction.updateLeaveAbsend(leaveDetails))
    }
    setTimeout(() => {
      specificDispatch(optionsAction.loadLeaveAbsend(searchValue))
      toast.success("Leave Request Updated successfully")
    }, 2000)
  }
  console.log(leaveModalData.fromTime, "from Time")
  ///response status modal open

  const editUpdateStatus = (leaveDetails) => {
    console.log(leaveDetails, "leaveDetail from edit update status")
    // setUpdateProcess({ label: leaveDetails.status, value: "" })
    setProcessRequest(true)
    setUpdateData({
      ...updateData,
      responseNotes: "",
      // responseStatus: [{ label: leaveDetails.status, value: "" }],
      requestNo: leaveDetails.requestNo,
    })
  }

  //Response Status update
  const updateLpndStatus = () => {
    const statusDetails = {
      _id: leaveId,
      requesttype: "Leave",
      // status: updateProcess.processStatusId,
      note: updateData.responseNotes,
    }
    specificDispatch(optionsAction.updateLpndStatus(statusDetails))
    setIsLoading(true)
    setTimeout(() => {
      specificDispatch(optionsAction.loadLeaveAbsend(searchValue))
      setProcessRequest(false)
      setIsLoading(false)
    }, 2000)
    console.log(employeeUpdate, "update employee")
  }
  console.log(leaveAttachment, "leaveAttachment")
  // Apply leave Attachment
  const handleApplyLeaveAttachment = async (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var leaveAttachmentValue = leaveAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              leaveAttachmentValue.push(res.data.data)
              await setLeaveAttachment(leaveAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }
  // Reject Attachment
  const handleChangeRejectAttachment = async (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      var file = e.target.files
      var fileArray = Array.from(file)
      var rejectAttachmentValue = rejectAttachment

      for (let x in fileArray) {
        const formData = new FormData()
        formData.append("file", fileArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              rejectAttachmentValue.push(res.data.data)
              await setRejectAttachment(rejectAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }

  const deleteLeaveRequest = () => {
    const leaveData = {
      // empCode: empId,
      _id: leaveRemoveId,
      status: 3,
    }
    setDeleteModal(false)
    specificDispatch(optionsAction.deleteLeaveAbsend(leaveData))
    setTimeout(() => {
      specificDispatch(optionsAction.loadLeaveAbsend(searchValue))
      toast.success(
        "Leave Details Deleted Successfully",
        {
          position: toast.POSITION.TOP_RIGHT,
        },
        1000
      )
    }, 2000)
    console.log(leaveData)
  }

  const absentTypeOptions = [
    {
      label: "COC",
      value: "COC",
    },
    {
      label: "Late",
      value: "Late",
    },
    {
      label: "Others",
      value: "Others",
    },
    {
      label: "Leave",
      value: "Leave",
    },
    {
      label: "Permission",
      value: "Permission",
    },
  ]

  //pagination
  const [loading, setLoading] = useState(false)
  // const MySearch = (props) => {
  //   let input

  //   const handleClick = () => {
  //     props.onSearch(input.value)
  //     console.log(input.value, "inputs")
  //     dispatch(
  //       optionsAction.loadLeaveAbsend({
  //         searchFilter: input.value,
  //         page: pageChange ? pageCount : 1,
  //         limit: 50,
  //       })
  //     )
  //     console.log(input.value, "input")
  //   }
  //   return (
  //     <div className="d-flex flex-row">
  //       <input
  //         className="form-control"
  //         placeholder="Search"
  //         ref={(n) => (input = n)}
  //         type="text"
  //       />
  //       <button className="btn btn-success mx-2" onClick={handleClick}>
  //         <i className="fas fa-search"></i>
  //       </button>
  //     </div>
  //   )
  // }
  const handleClick = (e) => {
    // props.onSearch(input.value)
    // console.log(input.value, "inputs")
    e.preventDefault()
    setSearchFilter(true)
    setDownloadLoading(true)
    dispatch(
      optionsAction.loadLeaveAbsend({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
      setDownloadLoading(false)
    }, 1200)
    // console.log(input.value, "input")
  }

  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  // const [downloadData, setDownloadData] = useState("")

  // console.log(downloadData, "downloadData")

  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchDepartment =
      departmentlist && departmentlist.value ? departmentlist.value : ""
    // var searchLeaveType =
    //   leaveTypeList && leaveTypeList.label ? [leaveTypeList.label] : ""
    var searchEmpCode =
      employeeCode && employeeCode.empCode ? employeeCode.empCode : ""

    var searchFromDate =
      leaveOptionsData && leaveOptionsData.fromDate
        ? leaveOptionsData.fromDate
        : ""
    var searchToDate =
      leaveOptionsData && leaveOptionsData.toDate ? leaveOptionsData.toDate : ""

    // var searchStatus = leaveStatus && leaveStatus.value ? leaveStatus.value : ""
    var searchLop = lopStatus && lopStatus.value ? lopStatus.value : ""
    console.log(employeeCode, "employee list")
    var searchvalue = {}
    // searchvalue.page = pageChange ? pageCount : 1
    // searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchDepartment) {
      searchvalue.departmentId = searchDepartment
    }
    if (searchEmpCode) {
      searchvalue.empCode = searchEmpCode
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchLop) {
      searchvalue.requestTypeId = searchLop
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)

    api.post(`/get_all_absent`, searchvalue).then((response) => {
      console.log(response, "response")
      const employeeDefaultExportTable = !isEmpty(response)
        ? response.data.Data.map((leaveDetails, index) => {
            slNo = slNo + 1

            // const dateFormate =
            //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
            var str = !isEmpty(leaveDetails.attachment)
              ? leaveDetails.attachment
              : []

            // console.log(str, "string attachments")
            const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
            // console.log(fileUrl, "string attachments")
            const attachments = isEmpty(fileUrl)
              ? ""
              : "https://api.alphaone.app/uploads/" + fileUrl
            // console.log(attachments, "attachment with alpha url")
            var fromDateTime = !isEmpty(leaveDetails.fromDate)
              ? moment(leaveDetails.fromDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
              : []

            var toDateTime = !isEmpty(leaveDetails.toDate)
              ? moment(leaveDetails.toDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
              : []

            console.log(attachments, "attachments")
            var appliedDate = !isEmpty(leaveDetails.createdAt)
              ? moment(leaveDetails.createdAt)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(`${dateFormate} hh:mm A`)
              : []
            var absentDate = !isEmpty(leaveDetails.absentDate)
              ? moment(leaveDetails.absentDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
              : []
            var date = !isEmpty(leaveDetails.date)
              ? moment(leaveDetails.date)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(dateFormate)
              : []
            const durationTime = !isEmpty(recordsMetaData)
              ? recordsMetaData.lossOfPayOptions.filter(
                  (data) =>
                    data.label === leaveDetails.requestTypeId.requestName
                )
              : []

            return {
              _id: leaveDetails._id,
              sNo: index + 1,
              empCode: leaveDetails.employeeCode,
              branchId: !isEmpty(leaveDetails.branchId)
                ? leaveDetails.branchId._id
                : "--",
              branchName: !isEmpty(leaveDetails.branchId)
                ? leaveDetails.branchId.name
                : "--",
              companyId: !isEmpty(leaveDetails.companyId)
                ? leaveDetails.companyId._id
                : "--",
              companyName: !isEmpty(leaveDetails.companyId)
                ? leaveDetails.companyId.name
                : "--",
              departmentId: !isEmpty(leaveDetails.departmentId)
                ? leaveDetails.departmentId._id
                : "--",
              departmentName: !isEmpty(leaveDetails.departmentId)
                ? leaveDetails.departmentId.name
                : "--",
              designationId: !isEmpty(leaveDetails.designationId)
                ? leaveDetails.designationId._id
                : "--",
              designationName: !isEmpty(leaveDetails.designationId)
                ? leaveDetails.designationId.name
                : "--",

              requestTypeName: !isEmpty(leaveDetails.requestTypeId)
                ? leaveDetails.requestTypeId.requestName
                : "--",
              requestTypeId: leaveDetails.requestTypeId,
              employeeCode: leaveDetails.empCode,
              employeeName: leaveDetails.empName,
              attachments: leaveDetails.attachment
                ? leaveDetails.attachment
                : "--",
              fromDate:
                leaveDetails.absentType === "Leave"
                  ? fromDateTime
                  : leaveDetails.absentType === "Permission"
                  ? date
                  : "--",
              toDate: leaveDetails.absentType === "Leave" ? toDateTime : "--",
              fromTime:
                leaveDetails.absentType === "Permission"
                  ? leaveDetails.startTime
                  : "--",
              toTime:
                leaveDetails.absentType === "Permission"
                  ? leaveDetails.endTime
                  : "--",
              request: leaveDetails.request,
              createdAt: appliedDate,
              absentDate: absentDate,
              absentStatus: leaveDetails.absentStatus
                ? leaveDetails.absentStatus
                : "--",
              absentMode: leaveDetails.absentMode,
              absentType: !isEmpty(leaveDetails.absentType)
                ? leaveDetails.absentType
                : "--",
              status: leaveDetails.status,
              leaveType: leaveDetails.leaveType,
              reason: !isEmpty(leaveDetails.reason)
                ? leaveDetails.reason
                : "--",
              requestNo: leaveDetails.requestNo,
              duration:
                durationTime && durationTime.map((data) => data.requestValue),
              key: index,
            }
          })
        : []
      setTimeout(() => {
        let headerData = [
          "SNo,Company, Branch,Department, Designation,Employee Code,Employee Name,Absent Type,Employee Default Setting,Default Date,Duration(Hrs),Reason,From Date,To Date,From Time,To Time,Attachment,Absent status,Applied Date",
        ]

        let usersCsv =
          !isEmpty(employeeDefaultExportTable) &&
          employeeDefaultExportTable.reduce((acc, user) => {
            const {
              sNo,
              companyName,
              branchName,
              departmentName,
              designationName,
              employeeCode,
              employeeName,
              absentType,
              requestTypeName,
              absentDate,
              duration,
              reason,
              fromDate,
              toDate,
              fromTime,
              toTime,
              attachments,
              absentStatus,
              createdAt,
            } = user
            acc.push([
              sNo,
              companyName,
              branchName,
              departmentName,
              designationName,
              employeeCode,
              employeeName,
              absentType,
              requestTypeName,
              absentDate,
              duration,
              reason,
              fromDate,
              toDate,
              fromTime,
              toTime,
              attachments,
              absentStatus,
              createdAt,
            ])

            console.log("test", acc)
            return acc
          }, [])
        console.log(usersCsv, "usersCsv")
        downloadFile({
          data: [...headerData, ...usersCsv].join("\n"),
          fileName: "LeaveAbsent.csv",
          fileType: "text/csv",
        })
        setDownloadLoading(false)
      }, 1800)
      return response.data
    })
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        {/* <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBtnStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "} */}
                      </Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: leave_list.length,
    data:
      !isEmpty(leave_list) && leave_list.length > 0
        ? leave_list.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result = !isEmpty(leave_list) && leave_list.length > 0 ? leave_list : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(departmentlist) ||
      !isEmpty(employeeCode) ||
      !isEmpty(leaveOptionsData.fromDate) ||
      !isEmpty(leaveOptionsData.toDate) ||
      !isEmpty(lopStatus)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchDepartment =
        departmentlist && departmentlist.value ? departmentlist.value : ""
      // var searchLeaveType =
      //   leaveTypeList && leaveTypeList.label ? [leaveTypeList.label] : ""
      var searchEmpCode =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""

      var searchFromDate =
        leaveOptionsData && leaveOptionsData.fromDate
          ? leaveOptionsData.fromDate
          : ""
      var searchToDate =
        leaveOptionsData && leaveOptionsData.toDate
          ? leaveOptionsData.toDate
          : ""

      // var searchStatus = leaveStatus && leaveStatus.value ? leaveStatus.value : ""
      var searchLop = lopStatus && lopStatus.value ? lopStatus.value : ""
      console.log(employeeCode, "employee list")
      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchDepartment) {
        searchvalue.departmentId = searchDepartment
      }
      if (searchEmpCode) {
        searchvalue.empCode = searchEmpCode
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      // if (searchStatus) {
      //   searchvalue.leaveStatus = searchStatus
      // }
      if (searchLop) {
        searchvalue.requestTypeId = searchLop
      }
      setPageLoad(!pageLoad)
      console.log("searchCompany", searchvalue)
      setLoading(true)
      dispatch(optionsAction.loadLeaveAbsend(searchvalue))
    } else {
      dispatch(
        optionsAction.loadLeaveAbsend({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }
    // setState(() => ({
    //   page,
    //   data: result.slice(currentIndex, currentIndex + sizePerPage),
    //   totalSize: result.length,
    //   sizePerPage
    // }))
    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"HRMS"} breadcrumbItem={title} />
          <Row>
            <Col lg="12" md="12" sm="12" xs="12" className="mb-4">
              <div className="filter-buttons" style={{ float: "right" }}>
                <Button
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "#ffffff",
                    border: "none",
                    marginTop: "-20px",
                  }}
                  onClick={() => {
                    setApplyLeaveModal(true)
                    applyButton()
                    // setapplyLeaveradio(false)
                    // setapplyPermissionradio(false)
                  }}
                >
                  Apply Employee Default
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {" "}
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          isMulti
                          onChange={(e) => handleCompany(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          isMulti
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="Department"
                          value={departmentlist}
                          onChange={(e) => setDepartmentlist(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Employee Code"}
                          >
                            {"Employee Code"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="employeeCode"
                          key={resetEmployee}
                          items={employeeOptions}
                          value={employeeCode}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEmployeeCode(e)}
                          onChange={(e) => setEmployeeCode(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="fromDate"
                          max={leaveOptionsData.toDate}
                          value={leaveOptionsData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="YYYY-MM-DD"
                          name="toDate"
                          min={leaveOptionsData.fromDate}
                          value={leaveOptionsData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Leave Status"}
                          >
                            {"Employee Default Setting"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="lopStatus"
                          value={lopStatus}
                          onChange={(e) => setLopStatus(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.lossOfPayOptions
                              : []
                          }
                          placeholder="Select Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                            onClick={() => resetFormDetails()}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => handleApply()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={leaveDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={leave_list.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
              {loading ? (
                <Modal
                  show={loading}
                  style={{ width: "7%", margin: "18% 50%" }}
                >
                  <Modal.Body>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2"
                      color="success"
                    />
                    {/* <span>Loading...</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}
              {btnLoading ? (
                <Modal
                  show={btnLoading}
                  style={{ width: "6.7%", margin: "18% 50%" }}
                >
                  <Modal.Body>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2"
                      color="success"
                    />
                    {/* <span>Loading...</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}
              {downloadLoading ? (
                <Modal
                  show={downloadLoading}
                  style={{ width: "6.7%", margin: "18% 50%" }}
                >
                  <Modal.Body>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2"
                      color="success"
                    />
                    {/* <span>Loading...</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}
              {openModal && (
                <Modal
                  show={openModal}
                  onHide={handleModal}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="6"
                      xs="6"
                      className="d-flex flex-row"
                    >
                      <span>REQUEST NO: </span>
                      <h1 className="request-header mx-2">{requestNo}</h1>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>SL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>CL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Company</Label>
                        <Input
                          type="text"
                          name="companyId"
                          value={leaveModalData.companyId}
                          onChange={(e) => modalChange(e)}
                          disabled
                          placeholder="Enter Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Branch</Label>
                        <Input
                          type="text"
                          name="branchDetail"
                          value={leaveModalData.branchDetail}
                          disabled
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Department</Label>
                        <Input
                          type="text"
                          name="departmentDetail"
                          value={leaveModalData.departmentDetail}
                          disabled
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Department"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Designation</Label>
                        <Input
                          type="text"
                          name="designationDetail"
                          value={leaveModalData.designationDetail}
                          disabled
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Designation"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-2">
                        <Label className="employee-label">Employee Code</Label>
                        <Input
                          type="text"
                          name="employeeCodeDetail"
                          value={leaveModalData.employeeCodeDetail}
                          disabled
                          onChange={(e) => modalChange(e)}
                          placeholder="Enter Employee Code"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>

                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="mt-4"
                    >
                      <Row>
                        <Col
                          xl="3"
                          lg="3"
                          md="3"
                          sm="3"
                          xs="3"
                          className="d-flex flex-column"
                        >
                          <Label
                            htmlFor="absent"
                            className={"form-label employee-label"}
                          >
                            Absent Type
                          </Label>

                          <Select
                            // type="text"
                            name="absentTypeList"
                            id="absent"
                            value={absentTypeList}
                            onChange={(e) => setAbsentTypeList(e)}
                            options={absentTypeOptions}
                            placeholder="Select Status"
                            classNamePrefix="select2-selection"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Row>
                      {absentTypeList.value === "COC" ||
                      employeeCodeDetails.absentType === "COC" ||
                      absentTypeList.value === "Late" ||
                      employeeCodeDetails.absentType === "Late" ||
                      absentTypeList.value === "Others" ||
                      employeeCodeDetails.absentType === "Others" ||
                      absentTypeList.value === "Leave" ||
                      employeeCodeDetails.absentType === "Leave" ||
                      absentTypeList.value === "Permission" ||
                      employeeCodeDetails.absentType === "Permission" ? (
                        <>
                          {" "}
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-2">
                            <Label className={"form-label"}>
                              Employee Default Setting
                            </Label>

                            <Select
                              name="leaveModalLop"
                              value={leaveModalLop}
                              onChange={(e) => setLeaveModalLop(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.lossOfPayOptions
                                  : []
                              }
                              placeholder="Select Status"
                              classNamePrefix="select2-selection"
                            />
                            <div>
                              <h6
                                style={{
                                  float: "right",
                                  marginTop: "4px",
                                  color: "#E40D8C",
                                }}
                              >
                                {!isEmpty(employeeCodeDetails.duration)
                                  ? employeeCodeDetails.duration
                                  : isEmpty(leaveModalLop)
                                  ? "0"
                                  : leaveModalLop.requestValue}
                                {isEmpty(employeeCodeDetails.duration)
                                  ? "0hrs"
                                  : "hrs"}
                              </h6>
                            </div>
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">
                              Employee Default Date
                            </Label>
                            <Input
                              type="date"
                              name="absentDate"
                              value={leaveModalData.absentDate}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {absentTypeList.value === "Leave" ? (
                        <>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">From Date</Label>
                            <Input
                              type="date"
                              name="fromDateList"
                              value={leaveModalData.fromDateList}
                              max={leaveModalData.toDateList}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select From Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">To Date</Label>
                            <Input
                              type="date"
                              name="toDateList"
                              value={leaveModalData.toDateList}
                              min={leaveModalData.fromDateList}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select To Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </>
                      ) : absentTypeList.value === "Permission" ? (
                        <>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">Date</Label>
                            <Input
                              type="date"
                              name="fromDateList"
                              value={leaveModalData.date}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select From Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">From Time</Label>
                            <Input
                              type="time"
                              name="fromTime"
                              value={leaveModalData.fromTime}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select To Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">To Time</Label>
                            <Input
                              type="time"
                              name="toTime"
                              value={leaveModalData.toTime}
                              onChange={(e) => modalChange(e)}
                              placeholder="Select To Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {absentTypeList.value === "COC" ||
                      absentTypeList.value === "Late" ||
                      absentTypeList.value === "Others" ||
                      absentTypeList.value === "Leave" ||
                      absentTypeList.value === "Permission" ? (
                        <>
                          <Col
                            xl="6"
                            lg="6"
                            md="6"
                            sm="6"
                            xs="12"
                            className="mt-2"
                          >
                            {" "}
                            <Label className="employee-label">
                              Description
                            </Label>
                            <Input
                              type="textarea"
                              name="notes"
                              value={leaveModalData.notes}
                              onChange={(e) => modalChange(e)}
                              disabled
                              placeholder="Enter Description"
                              className="employee-crowd-textarea"
                            />
                          </Col>

                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2 d-flex flex-column"
                          >
                            {" "}
                            <Label className="employee-label">
                              Attachement File
                            </Label>
                            <Input
                              type="file"
                              name="rejectAttachment"
                              // value={rejectAttachment}
                              onChange={(e) => handleChangeRejectAttachment(e)}
                            />
                            {!isEmpty(attachmentFile) ? (
                              <div className="mt-2">
                                <a
                                  onClick={() =>
                                    window.open(attachmentFile, "_blank")
                                  }
                                >
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#E40D8C",
                                    }}
                                  >
                                    View Attachments
                                  </span>
                                </a>
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        updateLeaveRequest()
                        handleModal()
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {applyLeaveModal && (
                <Modal
                  show={applyLeaveModal}
                  onHide={handleLeaveModal}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="6"
                      xs="6"
                      className="d-flex flex-row"
                    >
                      <span>Employee Default</span>
                      {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
                    </Col>
                    {/* <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>SL :</span>
                      <h1 className="request-header"></h1>
                    </Col>
                    <Col
                      xl="3"
                      lg="3"
                      md="3"
                      sm="3"
                      xs="3"
                      className="d-flex flex-column"
                    >
                      <span>CL :</span>
                      <h1 className="request-header"></h1>
                    </Col> */}
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label className="employee-label">
                          Employee Code <span className="required mx-1">*</span>
                        </Label>
                        <ReactSearchAutocomplete
                          name="empCodeData"
                          items={employeeCodeOptions}
                          value={empCodeData}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => employeeChange(e)}
                          onChange={(e) => employeeChange(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                        {simpleValidator.current.message(
                          "empCodeData",
                          empCodeData,
                          "required"
                        )}
                      </Col>{" "}
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Company</Label>
                        <Input
                          name="company"
                          value={leaveApplyData.company}
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Company"
                          disabled
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Branch</Label>
                        <Input
                          name="branch"
                          value={leaveApplyData.branch}
                          disabled
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Branch"
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Department</Label>
                        <Input
                          name="department"
                          value={leaveApplyData.department}
                          disabled
                          onChange={(e) => handleleaveChange(e)}
                          placeholder="Enter Department"
                        />
                      </Col>
                      <Col
                        xl="12"
                        lg="12"
                        md="12"
                        sm="3"
                        xs="3"
                        className="mt-2 mb-2"
                      >
                        <Row>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="d-flex flex-column"
                          >
                            {" "}
                            <Label className="employee-label">
                              Designation
                            </Label>
                            <Input
                              name="designation"
                              value={leaveApplyData.designation}
                              disabled
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Enter Designation"
                            />
                          </Col>
                        </Row>

                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="mt-4"
                        >
                          <Row>
                            <Col
                              xl="3"
                              lg="3"
                              md="3"
                              sm="3"
                              xs="3"
                              className="d-flex flex-column"
                            >
                              <Label
                                htmlFor="absent"
                                className={"form-label employee-label"}
                              >
                                Absent Type{" "}
                                <span className="required mx-1">*</span>
                              </Label>

                              <Select
                                type="text"
                                name="absentType"
                                id="absent"
                                value={absentType}
                                onChange={(e) => setAbsentType(e)}
                                options={absentTypeOptions}
                                placeholder="Select Status"
                                classNamePrefix="select2-selection"
                              />
                              {simpleValidator.current.message(
                                "absentType",
                                absentType,
                                "required"
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                      {/* {applyleaveradio&&(<> */}
                      {absentType.value === "COC" ||
                      absentType.value === "Late" ||
                      absentType.value === "Others" ||
                      absentType.value === "Leave" ||
                      absentType.value === "Permission" ? (
                        <>
                          {" "}
                          <Col
                            lg="3"
                            md="3"
                            sm="12"
                            xs="12"
                            className={
                              absentType.value === "COC" ||
                              absentType.value === "Late" ||
                              absentType.value === "Others"
                                ? "mt-2"
                                : "mt-3"
                            }
                          >
                            <Label className={"employee-label"}>
                              Employee Default Setting
                              <span className="required mx-1">*</span>
                            </Label>

                            <Select
                              type="text"
                              name="leaveLopStatus"
                              value={leaveLopStatus}
                              onChange={(e) => setLeaveLopStatus(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.lossOfPayOptions
                                  : []
                              }
                              placeholder="Select Status"
                              classNamePrefix="select2-selection"
                            />
                            <div>
                              <h6
                                style={{
                                  float: "right",
                                  marginTop: "4px",
                                  color: "#E40D8C",
                                }}
                              >
                                {isEmpty(leaveLopStatus)
                                  ? "0"
                                  : leaveLopStatus.requestValue}
                                hrs
                              </h6>
                            </div>
                            {simpleValidator.current.message(
                              "leaveLopStatus",
                              leaveLopStatus,
                              "required"
                            )}
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2"
                          >
                            <Label className="employee-label">
                              Employee Default Date
                              <span className="required mx-1">*</span>
                            </Label>
                            <Input
                              type="date"
                              name="absentDate"
                              value={leaveApplyData.absentDate}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                            {simpleValidator.current.message(
                              "absentDate",
                              leaveApplyData.absentDate,
                              "required"
                            )}
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {absentType.value === "Leave" ? (
                        <>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-3"
                          >
                            <Label className="employee-label">From Date</Label>
                            <Input
                              type="date"
                              name="fromDate"
                              value={leaveApplyData.fromDate}
                              max={leaveApplyData.toDate}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>{" "}
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-3"
                          >
                            <Label className="employee-label">To Date</Label>
                            <Input
                              type="date"
                              name="toDate"
                              value={leaveApplyData.toDate}
                              min={leaveApplyData.fromDate}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>{" "}
                        </>
                      ) : absentType.value === "Permission" ? (
                        <>
                          {" "}
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-3"
                          >
                            <Label className="employee-label">Date</Label>
                            <Input
                              type="date"
                              name="date"
                              value={leaveApplyData.date}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-3"
                          >
                            <Label className="employee-label">From Time</Label>
                            <Input
                              type="time"
                              name="fromTime"
                              value={leaveApplyData.fromTime}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-3"
                          >
                            <Label className="employee-label">To Time</Label>
                            <Input
                              type="time"
                              name="toTime"
                              value={leaveApplyData.toTime}
                              onChange={(e) => handleleaveChange(e)}
                              placeholder="Select Date"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {absentType.value === "COC" ||
                      absentType.value === "Late" ||
                      absentType.value === "Others" ||
                      absentType.value === "Leave" ||
                      absentType.value === "Permission" ? (
                        <>
                          <Col
                            xl="6"
                            lg="6"
                            md="6"
                            sm="6"
                            xs="16"
                            className="mt-2"
                          >
                            {" "}
                            <Label className="employee-label">Reason</Label>
                            <Input
                              type="textarea"
                              name="reason"
                              value={leaveApplyData.reason}
                              onChange={(e) => handleleaveChange(e)}
                              // disabled
                              placeholder="Enter Reason"
                              className="employee-crowd-textarea"
                            />
                          </Col>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="mt-2 d-flex flex-column"
                          >
                            {" "}
                            <Label className="employee-label">
                              Attachment File
                            </Label>
                            <Input
                              type="file"
                              name="leaveAttachment"
                              // value={leaveAttachment}
                              multiple
                              onChange={(e) => handleApplyLeaveAttachment(e)}
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {/* </>
                      )} */}
                      {/* {applypermissionradio&&(<> */}
                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className={"employee-label"}>Request Type</Label>

                        <Select
                          type="text"
                          name="leaveLopStatus"
                          value={leaveLopStatus}
                          onChange={(e) => setLeaveLopStatus(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.lossOfPayOptions
                              : []
                          }
                          placeholder="Select Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col xl="6" lg="6" md="6" sm="6" xs="16" className="mt-2">
                        {" "}
                        <Label className="employee-label">Reason</Label>
                        <Input
                          type="textarea"
                          name="reason"
                          value={leaveApplyData.reason}
                          onChange={(e) => handleleaveChange(e)}
                          // disabled
                          placeholder="Enter Reason"
                          className="employee-crowd-textarea"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="mt-2 d-flex flex-column"
                      >
                        {" "}
                        <Label className="employee-label">
                          Attachment File
                        </Label>
                        <Input
                          type="file"
                          name="leaveAttachment"
                          // value={leaveAttachment}
                          multiple
                          onChange={(e) => handleApplyLeaveAttachment(e)}
                        />
                      </Col> */}
                      {/* </>)} */}
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleLeaveModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn btn-success"
                      onClick={(e) => {
                        setConfirmModalView(true)
                        handleLeaveDetails(e)
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {confirmModalView && (
                <Modal
                  show={confirmModalView}
                  onHide={handleConfirmModal}
                  style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>Apply Leave Absent</span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure, you want to apply for the Leave Absent?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleConfirmModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleConfirmModal()
                        applyLeaveDetails()
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {processRequest && (
                <Modal show={processRequest} onHide={handleProcess}>
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>REQUEST NO:</span>
                      <h1 className="request-header">{updateData.requestNo}</h1>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <Col>
                      <Row className="d-flex flex-column">
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column"
                        >
                          <Label className="employee-label">
                            Response Notes
                          </Label>
                          <textarea
                            type="text"
                            name="responseNotes"
                            value={updateData.responseNotes}
                            onChange={(e) => updateChange(e)}
                            placeholder="Enter Response Notes"
                            className="employee-crowd-textarea"
                          />
                        </Col>
                        {/* <Col
                          xl="6"
                          lg="6"
                          md="6"
                          sm="12"
                          xs="12"
                          className="mt-2"
                        >
                          <Label className="event-label">Response Status</Label>
                          <Select
                            type="text"
                            name="updateProcess"
                            value={updateProcess}
                            options={updateProcessStatusOptions}
                            onChange={(e) => setUpdateProcess(e)}
                            placeholder="Select Response Status"
                          />
                        </Col> */}
                      </Row>
                    </Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleProcess}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleProcess()
                        updateLpndStatus()
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {approvalView && (
                <Modal
                  show={approvalView}
                  onHide={handleApprovalModal}
                  size="lg"
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>REQUEST NO:</span>
                      <h1 className="request-header">{requestNo}</h1>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <Col>
                      <Row className="d-flex flex-column">
                        {/* <div>No Records Found</div> */}
                        <Col xl="12" lg="12" md="12" sm="12" xs="12">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th style={{ width: "20px" }}>S.No</th>
                                <th style={{ width: "70px" }}>Approved By</th>
                                <th style={{ width: "70px" }}>Approved On</th>
                                <th style={{ width: "70px" }}>Notes</th>
                                <th style={{ width: "50px" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {approvedData.map((leaveDetails, index) => {
                                // let slNo = 0
                                console.log(
                                  leaveDetails,
                                  "request from data table leave"
                                )
                                const dateFormate =
                                  !isEmpty(dateSetting) && dateSetting
                                    ? dateSetting
                                    : ""
                                // if (leaveDataTable.requestNo === approvedId) {
                                return (
                                  <tr key={leaveDetails._id}>
                                    <td>{index + 1}</td>
                                    <td>{leaveDetails.approvedByName}</td>
                                    <td>
                                      {moment(leaveDetails.aprovedDate).format(
                                        dateFormate
                                      )}
                                    </td>
                                    <td>{leaveDetails.notes}</td>
                                    <td>{leaveDetails.status}</td>
                                  </tr>
                                )
                                // }
                              })}
                              {/* <tr>
                                 <td>1</td>
                                 <td>Mohammed Ashik(1401)</td>
                                 <td>19-10-2022</td>
                                 <td>Leave Approved</td>
                                 <td>Approved</td>
                               </tr>
                               <tr>
                                 <td>2</td>
                                 <td>Selvarajan(9999)</td>
                                 <td>20-10-2022</td>
                                 <td>Need medical Certificate</td>
                                 <td>Onhold</td>
                               </tr> */}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleApprovalModal}
                    >
                      Cancel
                    </Button>
                    {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleApprovalModal()
                       }}
                     >
                       Submit
                     </Button> */}
                  </Modal.Footer>
                </Modal>
              )}
              {isLoading ? (
                <Modal
                  show={isLoading}
                  style={{ width: "6.7%", margin: "20% 50%" }}
                >
                  <Modal.Body className="d-flex flex-column">
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2 mb-2"
                    />
                    <span>Loading...</span>
                    {/* <span>Response Successfully Updated</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Container>
        {deleteModal && (
          <Modal
            show={deleteModal}
            size="md"
            style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delete Leave</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              Are you sure, you want to Delete the Leave Details?
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    // deleteNightshift()
                    setDeleteModal(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  No{" "}
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    deleteLeaveRequest()
                  }}
                  className="btn btn-success buttons"
                  style={{ marginLeft: "15px" }}
                >
                  {" "}
                  Yes{" "}
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}
LeaveOptions.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  csvProps: PropTypes.any,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  searchBtnStyle: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeaveOptions)
)
